import React from 'react';
import PropTypes from 'prop-types';
import { Field, ErrorMessage, getIn } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { injectIntl, FormattedMessage } from 'react-intl';
import s from './TextAreaInput.module.scss';
import InputErrorMessage from './InputErrorMessage';
import formStyles from '../../styles/forms.module.scss';

/** Renders a simple text area input with associated label */
function TextAreaInput(props) {
  const { field, labelMsg, labelClass, labelHTML } = props;

  const { value, name, onChange } = field;

  const [id] = React.useState(() => uuidv4());

  const classNames = [s.textAreaInput];
  if (labelClass) {
    classNames.push(labelClass);
  }
  const className = classNames.join(' ');
  let isError = false;
  const {
    form: { touched },
  } = props;
  const {
    form: { errors },
  } = props;
  const touchedTemp = getIn(touched, name);
  const errorsTemp = getIn(errors, name);
  if (touchedTemp && errorsTemp) {
    isError = true;
  }

  return (
    <label
      htmlFor={id}
      className={`${className} ${isError ? formStyles.errorBorder : ''}`}
    >
      {labelHTML && (
        <>
          {' '}
          {labelHTML}
          <br />
          <br />
        </>
      )}
      {labelMsg && <FormattedMessage id={labelMsg} />}
      <Field
        component="textarea"
        id={id}
        name={name}
        className="form-control"
        onInput={onChange}
        value={value || ''}
      />
      <ErrorMessage name={name} component={InputErrorMessage} />
    </label>
  );
}

TextAreaInput.defaultProps = {
  labelClass: '',
  labelHTML: undefined,
};

TextAreaInput.propTypes = {
  /** Formik field object */
  field: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    name: PropTypes.string.isRequired,
  }).isRequired,
  /** intl object for formatting the label */
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  /** Label text id for the input label */
  labelMsg: PropTypes.string.isRequired,
  /** Class to apply to the label element */
  labelClass: PropTypes.string,
  /** The formik form object */
  form: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    touched: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    errors: PropTypes.object,
  }).isRequired,
  labelHTML: PropTypes.node,
};

export default injectIntl(TextAreaInput);
